import React from "react";
import PageHeaderComponent from "../../components/page-components/page-header.component";
import { Typography, makeStyles, Container } from "@material-ui/core";
import WeizenIcon from "../../components/form-inputs/weizen-icon";

import Rating from "@material-ui/lab/Rating";
const useStyles = makeStyles((theme) => ({
  red: {
    color: "red",
  },
  italic: {
    fontStyle: "italic",
  },
}));

const SpielregelnPage = () => {
  const classes = useStyles();
  return (
    <div className="page">
      <PageHeaderComponent
        title="Spielregeln"
        subtitle="Was es zu beachten gibt..."
      />

      <Container maxWidth="md">
        <Typography variant="h5" paragraph="true">
          Spielstruktur
        </Typography>

        <Typography variant="body1">
          Teilnehmen können Pfarrgemeinden des Dekanats Wetterau-West, die
          jeweils durch einen „Sämann“ (der natürlich auch eine „Säfrau“ sein
          kann) vertreten werden, auf den sich die Gemeinde geeinigt hat.
        </Typography>
        <Typography variant="body1">
          Der Sämann erhält Zugang zur Spielplattform, reicht Projektberichte
          aus der Pfarrgemeinde ein und bewertet in Vertretung der Gemeinde die
          Projekte der anderen Gemeinden.
        </Typography>
        <Typography variant="body1">
          Projektideen können durch Gemeindegremien, Gruppen, Einzelpersonen
          oder die gesamte Gemeinde ausgearbeitet und durchgeführt werden. Die
          Bewertungspunkte (
          <Rating
            name="bewertung"
            defaultValue={3}
            getLabelText={(value) => `${value} Heart${value !== 1 ? "s" : ""}`}
            size="large"
            icon={<WeizenIcon style={{ padding: 0 }} />}
          />{" "}
          „Ähren“) kommen der teilnehmenden Gemeinde insgesamt zugute und werden
          im „Kornspeicher“ eingelagert.
        </Typography>
        <Typography variant="body1" paragraph="true">
          Die Gemeinde mit dem höchsten Füllstand des Kornspeichers gewinnt nach
          Ablauf des Spiels den Wettbewerb.
        </Typography>
        <Typography variant="body1" paragraph="true">
          Das Spiel startet mit der Aussaat am{" "}
          <span className={classes.red}>15.08.2020.</span> und endet am{" "}
          <span className={classes.red}>29.08.2021</span>.
        </Typography>
        <Typography variant="h5" paragraph="true">
          Projekte
        </Typography>
        <Typography variant="body1">
          Ab Start der Aussaatzeit können Projektideen entwickelt, konkretisiert
          und umgesetzt werden.
        </Typography>
        <Typography variant="body1">
          Die durchführenden Personen, Gruppen oder Gremien müssen die Ideen
          nicht nur theoretisch erarbeiten, sondern sie auch ausprobieren und in
          die Realität umsetzen. Beispiel: Die Idee „Gospelchor mit
          Body-Percussion-Begleitung“ muss mindestens durch Proben am besten
          auch noch durch Auftritte realisiert werden.
        </Typography>
        <Typography variant="body1">
          Anschließend schreiben die Teilnehmer einen Projektbericht, der durch
          den eigenen Sämann eingereicht und anschließend durch alle
          teilnehmenden Sämänner bewertet wird.
        </Typography>
        <Typography variant="body1">
          Die dabei verdienten „Ähren“ werden dem Kornspeicher der Gemeinde
          gutgeschrieben.
        </Typography>
        <Typography variant="body1" paragraph="true">
          Es zählen nur Ideen, die innerhalb der Gemeinde neu sind bzw.
          Projekte, die ab dem 01.01.2020 begonnen wurden. Ein bereits seit
          Jahren stattfindendes Pfarrfest darf also nicht als neues Projekt
          eingereicht werden, wohl aber ein Kirchenkaffee, wenn es diesen bisher
          vor Ort nicht gab oder ein neuer Aspekt hinzukommt. Auch eine im März
          2020 neu gestartete Aktion kann beschrieben und angemeldet werden.
        </Typography>
        <Typography variant="h5" paragraph="true">
          Berichte
        </Typography>
        <Typography variant="body1" paragraph="true">
          Jeder Versuch wird bewertet, für den ein Bericht eingereicht wird, der
          den folgenden Kriterien entspricht:
        </Typography>
        <Typography variant="body1" className={classes.italic}>
          Er enthält Antworten auf die Fragen:
        </Typography>
        <ul>
          <li>
            <Typography varaint="body1">Was haben wir gemacht?</Typography>
          </li>
          <li>
            <Typography variant="body1">Was ist daran für uns neu?</Typography>
          </li>
          <li>
            <Typography variant="body1">
              Gab es einen ähnlichen Versuch schon mal bei uns?
            </Typography>
          </li>
          <li>
            <Typography variant="body1">Wie ist es gelaufen?</Typography>
          </li>
          <li>
            <Typography variant="body1">
              Haben sich unsere Erwartungen erfüllt?
            </Typography>
          </li>
          <li>
            <Typography variant="body1">Was haben wir gelernt?</Typography>
          </li>
        </ul>
        <Typography variant="body1">
          Er kann durch zwei aussagekräftige Fotos ergänzt werden. Der Umfang
          sollte 1-2 Seiten DIN A4 entsprechen.
        </Typography>
        <Typography variant="body1">
          Freiwillig können noch angegeben werden:
        </Typography>
        <ul>
          <li>
            <Typography variant="body1">
              Der Kontakt des/der jeweiligen Projekt-Verantwortlichen für
              Rückfragen
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Die Zustimmung, den Bericht auch außerhalb der internen Plattform
              z.B. auf der Webseite des Dekanats Wetterau-West veröffentlichen
              zu dürfen
            </Typography>
          </li>
        </ul>
        <Typography variant="h5" paragraph="true">
          Bewertung
        </Typography>
        <Typography>
          Jede teilnehmende Gemeinde darf alle eingehenden Berichte mit 1 - 5
          Ähren bewerten. Zusätzlich steht eine Kommentarfunktion für
          schriftliche Bewertungen zur Verfügung.
        </Typography>
        <Typography paragraph="true">
          Bewertungen können durch den Sämann abgegeben werden sowie durch die
          „Erntehelfer“. Der Sämann kann bis zu zehn Erntehelfer ernennen. Das
          Meinungsbild wird auf diese Weise auf eine breitere Basis gestellt.
          Gewertet wird am Ende der Durchschnitt der abgegebenen Bewertungen
          einer Gemeinde.
        </Typography>
        <Typography className={classes.italic}>
          Beispiele:
          <ul>
            <li>
              <Typography variant="body1">
                Eine Bewertung mit 3 Ähren wird abgegeben &rarr; Gesamtwertung:
                3 Ähren
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                Zwei Bewertungen mit 3 Ähren und 2 Bewertungen mit 4 Ähren
                werden abgegeben &rarr; Gesamtwertung 3,5 Ähren
              </Typography>
            </li>
          </ul>
        </Typography>
        <Typography variant="body1" paragraph="true">
          Der aktuelle Durchschnittswert der Bewertungen des jeweiligen Projekts
          wird erst angezeigt, wenn der/die Bewertende die Ähren vergeben hat.
        </Typography>
        <Typography paragraph="true">
          Der Bewertungszeitraum für die Projektberichte beträgt jeweils zwei
          Monate ab Freigabe des Berichts auf der Spielplattform. Danach wird
          das Ergebnis ermittelt und dem Kornspeicher der Gemeinde, aus der das
          Projekt kommt, gutgeschrieben.
        </Typography>
        <Typography variant="h5" paragraph="true">
          Schlusswertung
        </Typography>
        <Typography>
          Mit dem Ende der Erntezeit am{" "}
          <span className={classes.red}>29.08.2021</span> werden die Füllstände
          der Kornspeicher verglichen. Die Gemeinde mit der größten Anzahl an
          Ähren im Speicher gewinnt das Spiel und wird als „kreativste Gemeinde
          des Dekanats“ ausgezeichnet.
        </Typography>
        <Typography>
          Im Gottesdienst der Siegergemeinde erfolgt eine besondere Ehrung und
          die Überreichung eines Erinnerungspreises an die Aktion.
        </Typography>
        <Typography>
          Alle anderen Gemeinden freuen sich mit der Siegergemeinde und über die
          Vielzahl der Projektideen, die zur Nachahmung anregen.
        </Typography>
        <Typography>
          Alle eingereichten Ideen sind freigegeben und dürfen von den anderen
          Gemeinden nach Herzenslust nachgemacht und weiterentwickelt werden.
        </Typography>
      </Container>
    </div>
  );
};

export default SpielregelnPage;
